import { OpenInAppIcon } from './OpenInAppIcon';

/**
 * author: Google
 * id AF69E2E1-8119-49A2-8E24-915E2254522A
 * name open-in-app
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/open-in-app.svg
 * tags
 */
export const OpenInBrowserIcon = OpenInAppIcon;
export default OpenInBrowserIcon